var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgShift = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10394_99005)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.99911 13.7764C7.69758 13.7764 7.45312 14.0208 7.45312 14.3224V15.8747C7.45312 16.1762 7.69758 16.4207 7.99911 16.4207C8.30071 16.4207 8.5451 16.1762 8.5451 15.8747V14.3224C8.5451 14.0208 8.30064 13.7764 7.99911 13.7764Z",
    fill: "#0E3F6C",
    stroke: "#0E3F6C",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.99911 3.06561C8.30071 3.06561 8.5451 2.82115 8.5451 2.51962V0.967128C8.5451 0.665599 8.30071 0.421143 7.99911 0.421143C7.69758 0.421143 7.45312 0.665599 7.45312 0.967128V2.51962C7.45312 2.82115 7.69758 3.06561 7.99911 3.06561Z",
    fill: "#0E3F6C",
    stroke: "#0E3F6C",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.4411 12.2076L2.34301 13.3051C2.12971 13.5183 2.12964 13.864 2.34279 14.0772C2.44944 14.1839 2.58921 14.2372 2.72899 14.2372C2.86869 14.2372 3.00831 14.184 3.11496 14.0775L4.21305 12.9799C4.42635 12.7668 4.42642 12.4211 4.21327 12.2079C3.99997 11.9946 3.65432 11.9946 3.4411 12.2076Z",
    fill: "#0E3F6C",
    stroke: "#0E3F6C",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1724 4.7938C12.3121 4.7938 12.4518 4.74051 12.5585 4.63393L13.6564 3.53643C13.8696 3.3232 13.8697 2.97756 13.6565 2.76426C13.4433 2.55096 13.0977 2.55089 12.8844 2.76419L11.7864 3.86169C11.5732 4.07484 11.5731 4.42056 11.7863 4.63379C11.8929 4.74051 12.0326 4.7938 12.1724 4.7938Z",
    fill: "#0E3F6C",
    stroke: "#0E3F6C",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.64432 8.42099C2.64432 8.11946 2.39986 7.875 2.09833 7.875H0.545986C0.244456 7.875 0 8.11946 0 8.42099C0 8.72252 0.244456 8.96697 0.545986 8.96697H2.09833C2.39986 8.96697 2.64432 8.72252 2.64432 8.42099Z",
    fill: "#0E3F6C",
    stroke: "#0E3F6C",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.454 7.875H13.901C13.5994 7.875 13.355 8.11946 13.355 8.42099C13.355 8.72252 13.5994 8.96697 13.901 8.96697H15.454C15.7556 8.96697 16 8.72252 16 8.42099C16 8.11953 15.7556 7.875 15.454 7.875Z",
    fill: "#0E3F6C",
    stroke: "#0E3F6C",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.44096 4.63384C3.54753 4.74042 3.6873 4.79371 3.827 4.79371C3.9667 4.79371 4.10648 4.74042 4.21305 4.63384C4.42628 4.42061 4.42628 4.0749 4.21305 3.86167L3.11555 2.76417C2.90232 2.55094 2.5566 2.55094 2.34345 2.76417C2.13023 2.97739 2.13023 3.32311 2.34345 3.53626L3.44096 4.63384Z",
    fill: "#0E3F6C",
    stroke: "#0E3F6C",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5591 12.2078C12.3459 11.9946 12.0002 11.9945 11.7869 12.2077C11.5736 12.421 11.5736 12.7667 11.7869 12.9798L12.8842 14.0773C12.9909 14.184 13.1306 14.2373 13.2703 14.2373C13.41 14.2373 13.5498 14.184 13.6564 14.0774C13.8697 13.8642 13.8697 13.5185 13.6565 13.3053L12.5591 12.2078Z",
    fill: "#0E3F6C",
    stroke: "#0E3F6C",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.99969 4.17139C5.65653 4.17139 3.75024 6.07782 3.75024 8.42112C3.75024 10.7643 5.65653 12.6707 7.99969 12.6707C10.3431 12.6707 12.2495 10.7643 12.2495 8.42112C12.2495 6.07782 10.343 4.17139 7.99969 4.17139ZM7.99969 11.5787C6.25865 11.5787 4.84222 10.1622 4.84222 8.42112C4.84222 6.67994 6.25865 5.26336 7.99969 5.26336C9.74094 5.26336 11.1575 6.67994 11.1575 8.42112C11.1575 10.1622 9.74094 11.5787 7.99969 11.5787Z",
    fill: "#0E3F6C",
    stroke: "#0E3F6C",
    strokeWidth: 0.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10394_99005"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 0.420898)"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgShift, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/shift.61440dc2.svg";
export { ForwardRef as ReactComponent };